import React, { useState } from 'react';
import { Input, Button, Alert, Collapse } from 'reactstrap';
import Product from './Product';

const ProductGroups = ({
  group,
  editMode,
  setEditData,
  currentId,
  editData,
  onFieldProductGroupsUpdate,
  updateProductGroups,
  updateProductField,
  onFieldProductPriceUpdate,
  addProduct,
  deleteProduct,
  createMode,
  activeCollapse,
  openCollapse,
  deleteProductGroup,
  showDeleteModal,
}) => {
  const [indexOpen, setIsOpen] = useState(undefined);
  const toggle = index => setIsOpen(indexOpen === index ? undefined : index);

  const renderProducts = editMode && currentId === group._id ? editData.products : group.products;

  return (
    <div className="product-groups-item">
      {editMode && currentId === group._id && (
        <div className="edit-name-product-container">
          <Input
            className="edit-input-product"
            name="groupName"
            value={editData.groupName}
            placeholder="Please enter product groups name"
            onChange={e => onFieldProductGroupsUpdate(e.currentTarget.name, e.currentTarget.value)}
          />
        </div>
      )}
      <div className="action-accordion-container">
        <Button
          color="danger"
          onClick={() => {
            deleteProductGroup('productGroup', group._id);
          }}
        >
          Delete
        </Button>
        {editMode && currentId === group._id ? (
          <>
            <Button
              color="success"
              onClick={() => {
                updateProductGroups();
              }}
            >
              {typeof group.__v === 'number' ? 'Update' : 'Save'}
            </Button>
            <Button onClick={() => setEditData(null, !editMode)}>Cancel</Button>
          </>
        ) : (
          <Button
            color="info"
            disabled={editMode || createMode}
            onClick={() => {
              setEditData(group, !editMode);
              if (activeCollapse !== group._id) {
                openCollapse(group._id);
              }
            }}
          >
            Edit
          </Button>
        )}
      </div>
      <div
        className={`product-groups-header${
          activeCollapse === group._id ? ' product-groups-header_open' : ''
        }`}
        onClick={() => openCollapse(group._id)}
      >
        {editMode && currentId === group._id ? (
          ' '
        ) : (
          <span className="product-group-name">{group.groupName}</span>
        )}
      </div>
      <Collapse isOpen={activeCollapse === group._id}>
        <div className="collapse-content">
          {editMode && currentId === group._id && (
            <div className="actions-product-container">
              <Button
                color="success"
                onClick={() => {
                  toggle(renderProducts.length);
                  addProduct();
                }}
              >
                Add Product
              </Button>
            </div>
          )}
          {renderProducts.length ? (
            <div className="collapse-container">
              {renderProducts.map((item, i) => (
                <Product
                  key={i}
                  product={item}
                  editMode={editMode}
                  currentId={currentId}
                  groupId={group._id}
                  editData={editData}
                  productIndex={i}
                  updateProductField={updateProductField}
                  onFieldProductPriceUpdate={onFieldProductPriceUpdate}
                  deleteProduct={deleteProduct}
                  indexOpen={indexOpen}
                  onToggleCollapse={toggle}
                />
              ))}
            </div>
          ) : (
            <Alert color="info">Product not found</Alert>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default ProductGroups;
